import { Capacitor } from '@capacitor/core';

export const getIsNativePlatform = () => Capacitor.isNativePlatform();

export const getNativePlatform = () => Capacitor.getPlatform();

/**
 * Dev/QA override to preview the NATIVE mobile layout (bottom nav, etc.) inside a desktop browser,
 * where `Capacitor.isNativePlatform()` is always false. Never true for real web users — it requires
 * an explicit opt-in, so production web is unaffected.
 *
 * Enable via either:
 *   - URL query param: `?mobileNav=1`
 *   - localStorage:    `localStorage.setItem('forceMobileNav', '1')`
 */
export const getIsMobileLayoutForced = () => {
  const hasQueryFlag = new URLSearchParams(window.location.search).has('mobileNav');
  const hasStorageFlag = window.localStorage?.getItem('forceMobileNav') === '1';

  return hasQueryFlag || hasStorageFlag;
};

// iPadOS reports a desktop Mac platform; only the touch points give it away.
export const checkIsIpadOs = () =>
  window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1;

export const checkIsAndroid = () => /Android/.test(window.navigator.userAgent);

export const isTouchPrimary = () => {
  const isCoarsePointer = window.matchMedia?.('(pointer: coarse)')?.matches ?? false;
  const hasFinePointer = window.matchMedia?.('(any-pointer: fine)')?.matches ?? false;

  return isCoarsePointer && !hasFinePointer;
};
